var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCareer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 151.195,
    y: 94.121,
    width: 44.755,
    height: 44.695,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 128.594,
    y: 102.435,
    width: 44.804,
    height: 44.802,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "e"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "e"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 67.299,
    y: 26.456,
    width: 83.76,
    height: 119.198,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "g"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "g"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 48.123,
    y: 66.641,
    width: 63.785,
    height: 57.157,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "i"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    x: 87.326,
    y: 6.277,
    width: 50.052,
    height: 50.049,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "k"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "k"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    x: 54.569,
    y: 64.084,
    width: 57.996,
    height: 47.244,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "m"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "m"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: 38.192,
    y: 135.726,
    width: 44.794,
    height: 44.801,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "o"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "o"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "p",
    x: 60.691,
    y: 127.356,
    width: 44.802,
    height: 44.798,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "q"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "q"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "r",
    x: 106.224,
    y: 110.516,
    width: 44.802,
    height: 44.798,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "s"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "s"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "t",
    x: 83.198,
    y: 118.984,
    width: 44.798,
    height: 44.787,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "u"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "u"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.617 3.955)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.618 -3.955)",
    stroke: "#fff",
    strokeWidth: 4,
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 98,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.809 17.322)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -53.19, -21.28)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M873.47-370.784a7.213,7.213,0,0,1,7.339,7.349,7.217,7.217,0,0,1-7.357,7.346,7.243,7.243,0,0,1-7.4-7.307A7.183,7.183,0,0,1,873.47-370.784Zm5.2,7.3a5.29,5.29,0,0,0-5.318-5.279,5.22,5.22,0,0,0-5.111,5.343,5.089,5.089,0,0,0,5.293,5.223A5.164,5.164,0,0,0,878.669-363.484Z",
    transform: "translate(-699.86 479.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -53.19, -21.28)",
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M859.58-361.075A7.252,7.252,0,0,1,867.1-368.4a7.367,7.367,0,0,1,7.286,7.346,7.473,7.473,0,0,1-7.5,7.455A7.419,7.419,0,0,1,859.58-361.075Zm7.279,5.262a5.144,5.144,0,0,0,5.326-5.076,5.331,5.331,0,0,0-5.132-5.483,5.38,5.38,0,0,0-5.36,5.29A5.2,5.2,0,0,0,866.859-355.813Z",
    transform: "translate(-715.99 485.84)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -53.19, -21.28)",
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M859.122-371.022a12.978,12.978,0,0,0-4.165,5.786q-1.772,5.193-3.62,10.361c-1,2.815-3.391,3.9-6.278,2.9a4.5,4.5,0,0,1-2.647-5.979c1.381-4.039,2.791-8.066,4.186-12.1a16.085,16.085,0,0,1,4.077-6.316c3.884-3.764,7.518-7.764,11.17-11.743A5.959,5.959,0,0,1,868-389.991a45.71,45.71,0,0,1,4.886,1.43,6.377,6.377,0,0,1,4.032,3.989,38.934,38.934,0,0,1,1.908,9.578,11,11,0,0,1,.194,2.207c-.148,1.518.734,1.786,1.947,1.919,3.631.393,7.265.8,10.889,1.293,2.745.369,4.263,2.467,3.975,5.3a4.338,4.338,0,0,1-4.879,4.01c-3.512-.3-7.012-.728-10.513-1.146-.686-.081-1.079-.042-1.1.784q-.085,3.464-.25,6.921a1.348,1.348,0,0,0,.977,1.473c3.807,1.62,7.585,3.311,11.4,4.91,2.478,1.04,3.525,2.446,3.585,5.181.084,3.838-.277,7.659-.552,11.479-.348,4.9-.913,9.8-1.181,14.7-.169,3.135-3.308,5.1-6.355,4.766-3.874-.429-5.553-2.78-5.205-6.639.449-4.984.759-9.979,1.129-14.973.091-1.258.2-2.516.238-3.775a2.044,2.044,0,0,0-1.255-2.109c-3.282-1.406-6.566-2.812-9.869-4.165-1.459-.6-1.568-.523-1.3,1.055,1.094,6.527-.165,12.8-1.834,19.071-1.512,5.68-2.794,11.42-4.172,17.135-.907,3.765-3.782,5.388-7.494,4.228-3.254-1.023-4.632-3.448-3.838-6.762,1.8-7.494,3.617-14.984,5.388-22.484.784-3.325.414-6.671-.067-10a111.709,111.709,0,0,1-1.315-14.425,79.068,79.068,0,0,1,1.322-12.449C858.841-368.544,858.95-369.609,859.122-371.022Z",
    transform: "translate(-759.81 431.65)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -53.19, -21.28)",
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M836.52-363.228a7.825,7.825,0,0,1,.25-.861q2.594-6.838,5.212-13.672c.131-.337.113-.875.611-.879.376,0,.485.457.654.745,2.513,4.383,4.931,8.819,7.782,13a1.166,1.166,0,0,1,.084,1.226c-.38.868.035,1.269.829,1.543s1.508.6,1.878-.534a1.176,1.176,0,0,1,.913-.84c4.91-1.054,9.567-2.921,14.305-4.534.359-.123.777-.432,1.1-.137.358.327-.018.728-.144,1.069q-1.787,4.771-3.6,9.529c-.542,1.427-1.068,2.854-1.645,4.266-.721,1.772-1.641,2.186-3.378,1.526q-11.535-4.392-23.071-8.791A2.342,2.342,0,0,1,836.52-363.228Z",
    transform: "translate(-773.39 460.28)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -53.19, -21.28)",
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M867.878-385.883a9.976,9.976,0,0,1-10.214,10A9.989,9.989,0,0,1,847.826-386a10.1,10.1,0,0,1,10.063-9.936A9.866,9.866,0,0,1,867.878-385.883Z",
    transform: "translate(-745.5 417.21)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -53.19, -21.28)",
    filter: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M848.208-376.536c-.756-1.1-.612-1.564.618-1.99a9.055,9.055,0,0,1,10.084,3.951c.407.759.281,1.322-.562,1.895,2.221.847,4.284,1.645,6.351,2.418a2.221,2.221,0,0,1,1.617,1.859,1.239,1.239,0,0,1-.865,1.539c-4.755,1.571-9.448,3.332-14.3,4.6-.84.221-1.413.285-1.072-.91.221-.777-.475-.928-.988-1.125-.537-.211-1.171-.682-1.6.106-.577,1.044-.956.5-1.357-.106-2.752-4.144-5.124-8.509-7.567-12.836a1.146,1.146,0,0,1,.162-1.539,1.936,1.936,0,0,1,2.133-.584c1.881.7,3.754,1.406,5.631,2.106.573.211,1.15.408,1.722.615l9.476,3.631c-1.606-2.615-3.532-3.859-5.88-4.074A21.924,21.924,0,0,0,848.208-376.536Z",
    transform: "translate(-768.77 458.47)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -53.19, -21.28)",
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.683-351.55a7.262,7.262,0,0,1,7.4-7.321,7.48,7.48,0,0,1,7.392,7.571,7.412,7.412,0,0,1-7.423,7.23A7.258,7.258,0,0,1,833.683-351.55Z",
    transform: "translate(-780.49 509.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -53.19, -21.28)",
    filter: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M840.156-354.05a7.317,7.317,0,0,1,7.533-7.2,7.513,7.513,0,0,1,7.268,7.553,7.4,7.4,0,0,1-7.4,7.244A7.319,7.319,0,0,1,840.156-354.05Z",
    transform: "translate(-764.46 503.61)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -53.19, -21.28)",
    filter: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M860.627-351.291a7.314,7.314,0,0,1-7.371-7.627,7.367,7.367,0,0,1,7.455-7.17,7.453,7.453,0,0,1,7.346,7.592A7.375,7.375,0,0,1,860.627-351.291Z",
    transform: "translate(-732.03 491.61)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -53.19, -21.28)",
    filter: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M853.861-348.847a7.242,7.242,0,0,1-7.23-7.5,7.329,7.329,0,0,1,7.349-7.286,7.467,7.467,0,0,1,7.449,7.518A7.483,7.483,0,0,1,853.861-348.847Z",
    transform: "translate(-748.43 497.62)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/Career.438a9f231e2fb826b1187c122c0bdd56.svg";
export { ForwardRef as ReactComponent };